/**
 * @file apps/web/src/components/NextActionBanner.tsx
 * @description Single prominent "what to do next" card for the project
 * Overview page. Message and CTA come from the GET /projects/:id/overview
 * endpoint's next-action priority waterfall (first unmet phase wins).
 */

import { Link } from 'react-router-dom';
import { ArrowRight, Sparkles } from 'lucide-react';

export interface NextAction {
  message:  string;
  ctaLabel: string;
  ctaHref:  string;
}

export function NextActionBanner({ action }: { action: NextAction }) {
  return (
    <div className="card p-5 bg-sky/40 border-blue/20 flex items-center justify-between gap-4 flex-wrap">
      <div className="flex items-start gap-3 min-w-0">
        <Sparkles size={18} className="text-blue shrink-0 mt-0.5" />
        <p className="text-sm font-medium text-ink leading-relaxed">{action.message}</p>
      </div>
      <Link to={action.ctaHref} className="btn-primary text-sm shrink-0">
        {action.ctaLabel}
        <ArrowRight size={14} />
      </Link>
    </div>
  );
}
